/*
 * @Author: zengsheng 12181283
 * @Date: 2026-02-10 15:42:23
 * @LastEditors: zengsheng 12181283
 * @LastEditTime: 2026-02-10 15:42:30
 * @FilePath: \itoss_frontend\src\app\reducers\close_reducer.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const UPDATE_CLOSE_STATE = 'UPDATE_CLOSE_STATE';

const initialState = {
  isClosed: false,
  closeTime: null,
  closeReason: null
};

function closeReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_CLOSE_STATE:
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}

export default closeReducer;